"use client";

import { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import SupportLegal from "../../../member/components/Support";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Main Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          {/* Support Content */}
          <div className="w-full bg-[#FFFFFF]">
            <main className="min-h-screen bg-[#FFFFFF] w-full">
              <SupportLegal />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoField({ label, value, classNameLabel, classNameValue }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      <div className={`${classNameLabel}`}>{label}</div>
      <div className={`md:col-span-2 font-medium text-right ${classNameValue}`}>
        {value}
      </div>
    </div>
  );
}
